var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "van-list",
        _vm._l(_vm.list, function(item) {
          return _c("van-cell", { key: item.personCode }, [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.changePerson(item)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(item.personName))]),
                item.isDefault == 1
                  ? _c("span", [_vm._v("(当前用户)")])
                  : _vm._e()
              ]
            ),
            item.isDefault != 1
              ? _c(
                  "span",
                  { staticStyle: { float: "right" } },
                  [
                    _c("van-icon", {
                      staticStyle: { "padding-top": "5px" },
                      attrs: { name: "cross", size: "20px" },
                      on: {
                        click: function($event) {
                          return _vm.cancelUserBind(item)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        }),
        1
      ),
      _c(
        "div",
        {
          staticClass: "login-btn",
          staticStyle: {
            "padding-left": "20px",
            "padding-right": "20px",
            "padding-top": "20px"
          }
        },
        [
          _c(
            "van-button",
            {
              attrs: { block: "", type: "info" },
              on: { click: _vm.addAccount }
            },
            [_vm._v(" 添 加 ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }